import * as helpers from '../../tools/helpers';

class BfvMyAccountInputControl {
  constructor(options = {}) {
    this.$root = options.element;
    this.$inputFields = Array.prototype.slice.call(this.$root.querySelectorAll('.js-input-wrapper'));
    this.$submitButton = this.$root.querySelector('.js-edit-info-submit-button');
    this.$marketingCheckbox = this.$root.querySelector('#marketingCheckbox-0');
    this.$birthdayInput = this.$root.querySelector('.bfv-my-account-edit-info__birthdate-input');
    this.$birthdayInputWrapper = this.$root.querySelector('.bfv-my-account-edit-info__birthdate-input-wrapper');
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.$inputFields.forEach(($inputField) => {
      const $inputAtom = $inputField.querySelector('.js-input-atom');
      const $input = $inputField.querySelector('.js-input');

      $inputAtom.dataset.invalidInputText = $inputField.dataset.invalidInputText;
      $inputAtom.dataset.emptyInputText = $inputField.dataset.emptyInputText;

      $input.addEventListener('input', () => {
        this.checkInputForErrors($inputAtom);
      });
    });

    if (this.$marketingCheckbox) {
      this.$marketingCheckbox.addEventListener('change', () => {
        this.updateBirthdayRequirement();
      });
    }

    this.$submitButton.addEventListener('click', (evt) => {
      if (!this.validateFields()) {
        evt.preventDefault();
      }
    });
  }

  updateBirthdayRequirement() {
    if (this.$marketingCheckbox && this.$birthdayInput) {
      if (this.$marketingCheckbox.checked) {
        this.$birthdayInput.removeAttribute('disabled');
        this.$birthdayInputWrapper.classList.remove('bfv-my-account-edit-info__birthdate-input-wrapper--hidden');
      } else {
        this.$birthdayInput.setAttribute('disabled', true);
        this.$birthdayInputWrapper.classList.add('bfv-my-account-edit-info__birthdate-input-wrapper--hidden');
      }
    }
  }

  checkInputForErrors($inputAtom) {
    const $input = $inputAtom.querySelector('.js-input');

    BfvMyAccountInputControl.clearInputError($inputAtom);

    switch ($input.name) {
      case 'passwort-neu':
      case 'passwort-neu2':
        return this.validateBothPasswordFields();

      default:
        break;
    }

    return false;
  }

  static clearInputError($inputAtom) {
    const $errorNotification = $inputAtom.querySelector('.input__notification');
    $inputAtom.classList.remove('input--error');
    $errorNotification.innerHTML = '';
  }

  static displayInputError(errorString, $inputAtom) {
    const $errorNotification = $inputAtom.querySelector('.input__notification');
    $inputAtom.classList.add('input--error');
    $errorNotification.innerHTML = errorString;
  }

  validateBothPasswordFields() {
    let foundError = false;

    const $passwortAtom1 = this.$inputFields.find(($inputField) => {
      const $input = $inputField.querySelector('.js-input');
      return ($input.name === 'passwort-neu');
    }).querySelector('.js-input-atom');
    const $passwortInput1 = $passwortAtom1.querySelector('.js-input');

    const $passwortAtom2 = this.$inputFields.find(($inputField) => {
      const $input = $inputField.querySelector('.js-input');
      return ($input.name === 'passwort-neu2');
    }).querySelector('.js-input-atom');
    const $passwortInput2 = $passwortAtom2.querySelector('.js-input');

    if (!helpers.validatePassword($passwortInput1.value)) {
      BfvMyAccountInputControl.displayInputError($passwortAtom1.dataset.invalidInputText, $passwortAtom1);
      foundError = true;
    } else {
      BfvMyAccountInputControl.clearInputError($passwortAtom1);
    }

    if ($passwortInput1.value !== $passwortInput2.value) {
      BfvMyAccountInputControl.displayInputError($passwortAtom2.dataset.invalidInputText, $passwortAtom2);
      foundError = true;
    } else {
      BfvMyAccountInputControl.clearInputError($passwortAtom2);
    }

    return foundError;
  }

  validateFields() {
    let errorFree = true;

    this.$inputFields.forEach(($inputField) => {
      const $inputAtom = $inputField.querySelector('.js-input-atom');

      if (this.checkInputForErrors($inputAtom)) {
        errorFree = false;
      }
    });

    return errorFree;
  }
}

export default BfvMyAccountInputControl;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvMyAccountInputControl/index.js